import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
    return (
        <div>
            <div>
  <div className="breadcrumb-banner-area" style={{backgroundImage: 'url(./img/service-header.png)'}}>
    <div className="container">
      <div className="row mb-5">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">
            <h2>Our Services</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* breadcrumb-banner-area-end */}
  <div className="container">
    <div className="row mb-5">
      <div className="col-sm-12 col-lg-4">
        <img src="./img/service-main-image.png" className="img-fluid" />
      </div>
      <div className="service-sec-text-top col-sm-12 col-lg-8">
        <div>
          <h1>“We Aim for Excellence”</h1>
          <p>Techarabiya is an emergent Fintech solution enterprise. We innovate, we build, and we deliver. Our services are re-defining customers’ experience through digital solutions. 
          </p>
          <h4>We build tomorrow, today...</h4>
        </div>
      </div>
    </div>
  </div>
  <div className="container">
    <div className="row mb-5">
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
        <img src="./img/service-image-1.png" className="img-fluid img-service" alt="" />
      </div>
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12 align-self-center">
        <div>
          <h3><b>Digital Innovation Lab</b></h3>
          <p>INNOVATION BEGINS HERE …Lets build something amazing together and transform your Today with Tomorrows technology. In the world of 
            business, the words “disrupt, innovate, and transform” have become the new normal. For companies looking to make their mark, digital 
            transformation is now the pathway to create revenue and new value, increase profitability, and improve employee and customer retention. It can also help remove IT complexities, risks, and barriers to 
            innovation, ...
          </p>
          <Link to="/DigitalInnovationLab" className="btn btn-primary">READ MORE</Link>
          <br />
        </div>
      </div>
    </div>
  </div>
  <div className="container">
    <div className="row mb-5">
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12 align-self-center">
        <h3><b>Bespoke Software Development</b></h3>
        <p>We build Simple but Powerful Customized Products for Startups and Enterprises … We translate your ideas and requirements into rich 
          technology solutions on a variety of technology platforms. Techarabiya master agile development capabilities help you create innovative, 
          engaging products, while simultaneously ensuring rapid time to market. Techarabiya major strength is the ability to provide high quality 
          services quickly with sustainable savings over the lifecycle of software products. 
        </p>
        <Link to="/SoftwareDevelopment" className="btn btn-primary">READ MORE</Link>
        <br /> <br />
      </div>
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
        <img src="./img/service-image-2.png" className="img-fluid img-service" alt="" />
      </div>
    </div>
  </div>
  <div className="container">
    <div className="row mb-5">
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
        <img src="./img/service-image-3.png" className="img-fluid  img-service" alt="" />
      </div>
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12 align-self-center">
        <div>
          <h3><b>Mobile App Development</b></h3>
          <p>We are an expert in providing scalable and high-quality iOS and 
            Android apps. Techarabiya turns your ideas into convenient, appealing and quick apps. We offer the finest range of apps inclusive of the 
            premium quality desired by different brands &amp; compatible with Android, iOS and Windows. We develop mobile apps that make your mobile strategy a success. Techarabiya has UI/UX specialist, market analyst and people who are expert in creating both cross-platform and native apps.
          </p>
          <Link to="/MobileApp" className="btn btn-primary">READ MORE</Link>
          <br />
        </div>
      </div>
    </div>
  </div>
  <div className="container">
    <div className="row mb-5">
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12 align-self-center">
        <h3><b>E-Commerce Development
            &amp; Web Designing</b></h3>
        <p>The web is flooding with eCommerce websites, but only the best ones create a difference. At Techarabiya, we build innovative e-commerce platform dedicated to your needs or modify existing solutions to help scale up your business. Cross-platform sales automation is one of our specialization. We build large scale systems based on Amazon, eBay, Rakuten marketplaces and platforms such as Magneto or Shopify. 
        </p>
        <Link to="/Ecommerce" className="btn btn-primary">READ MORE</Link>
        <br /> <br />
      </div>
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
        <img src="./img/service-image-4.png" className="img-fluid img-service" alt="" />
      </div>
    </div>
  </div>
  <div className="container">
    <div className="row mb-5">
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
        <img src="./img/service-image-5.png" className="img-fluid img-service" alt="" />
      </div>
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12 align-self-center">
        <div>
          <h3><b>Custom IoT Software 
              Development</b></h3>
          <p>Techarabiya renders internet of things development services, delivering custom apps that harness the power of connected devices to advance lifestyles and empower enterprises with next-generation IoT products. At Techarabiya, we specialize in building large scale Enterprise IoT 
            solutions specifically for Retail, Insurance and Banking &amp; Finance 
            Industry. We offers full range of Internet of Things services. We work at mobile, web, data and embedded levels to align with all your tech needs ...
          </p>
          <Link to="/Iot" className="btn btn-primary">READ MORE</Link>
          <br />
        </div>
      </div>
    </div>
  </div>
  <div className="container">
    <div className="row mb-5">
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12 align-self-center">
        <h3><b>Blockchain Development</b></h3>
        <p>We offer our clients within a specific application a full software solution on Blockchain basis including conceptualization, design, development, quality assurance and ongoing support. We assist you all the way and find the best bespoke solution for you. Our Blockchain application is a complete package, customized according to your needs.  Techarabiya aiming to bring a new change in the Blockchain technology. 
        </p>
        <Link to="/Blockchain" className="btn btn-primary">READ MORE</Link>
        <br /> <br />
      </div>
      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
        <img src="./img/service-image-6.png" className="img-fluid img-service" alt="" />
      </div>
    </div>
  </div>
</div>

        </div>
    )
}

export default Services
